import { Check } from "lucide-react";
import type { DashboardData, Owner } from "../../types";
import Modal from "../../components/Modal";
import ExpenseEntry from "./ExpenseEntry";
import type { EntryPreset } from "./use-entry-modal";

/** The sheet the "Add transaction" button opens. Offers "Done" once something has been saved. */
export default function AddTransactionModal({ data, profile, preset, saved, onSaved, onClose, online = true }: {
  data: DashboardData;
  profile: Owner;
  preset: EntryPreset | null;
  saved: boolean;
  onSaved: () => Promise<DashboardData | undefined>;
  onClose: () => void;
  online?: boolean;
}) {
  return (
    <Modal title={saved ? "All done" : "Add transaction"} onClose={onClose}>
      <ExpenseEntry data={data} profile={profile} preset={preset || undefined} onSaved={onSaved} online={online} />
      {saved && (
        <button className="primary-button" onClick={onClose}>
          Done <Check size={18} />
        </button>
      )}
    </Modal>
  );
}
